import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, style, animate, animateChild, query } from '@angular/animations';

@Component({
  selector: '[app-loading-content]',
  templateUrl: './loading-content.component.html',
  styleUrls: ['./loading-content.component.scss'],
  animations:[
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
        query('@*', animateChild(), { optional: true }),

      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 })),
        query('@*', animateChild(), { optional: true }),
      ])
    ]),
  ]
})
export class LoadingContentComponent implements OnInit {

  /**
   * A defined height for make the component load good.
   *
   * @type {number}
   * @memberof LoadingContentComponent
   */
  @Input()
  height:number;


  /**
   * The loading indicator for the input.
   *
   * @type {boolean}
   * @memberof LoadingContentComponent
   */
  @Input()
  loading:boolean = true;
  constructor() { }

  ngOnInit() {
  }

}
